import { FC } from 'react';

import { DropdownButton } from '@/shared/components/DropdownButton';
import { ContactType } from '@/shared/lib/sj-orm';

import { SelectContactType } from '../SelectContanctType';

type DropdownButtonContactTypeProps = {
  onSelect: (type: ContactType) => void;
  filter?: (type: ContactType) => boolean;
  text: string;
};

export const DropdownButtonContactType: FC<DropdownButtonContactTypeProps> = ({
  onSelect,
  filter,
  text,
}) => (
  <DropdownButton
    listPosV="top"
    btnVariant="default"
    onSelect={onSelect}
    renderList={(handleSelect, listRef, selectStyles) => (
      <SelectContactType
        filter={filter}
        style={selectStyles}
        onSelect={handleSelect}
        ref={listRef}
      />
    )}
  >
    {text}
  </DropdownButton>
);
